import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { initLocale } from '@/model/global/actions';
import { makeSelectLocale } from '@/model/global/selectors';

const selectLocale = makeSelectLocale();

export const withLocalization = (Component: React.FC<{ [k in string]: unknown }>) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const [parsing, setParsing] = useState<'NOT_YET' | 'IN_PROGRESS' | 'FINISHED'>('NOT_YET');
  const dispatch = useDispatch();
  const locale = useSelector(selectLocale);
  useEffect(() => {
    if (parsing === 'NOT_YET') {
      setParsing('IN_PROGRESS');
      (async (): Promise<void> => {
        try {
          await initLocale()(dispatch);
        } finally {
          setParsing('FINISHED');
        }
      })();
    }
  }, [dispatch, locale, parsing]);
  return parsing === 'FINISHED' ? <Component locale={locale} {...props} /> : <></>;
};

export default withLocalization;
